export class LocationLink {
  id: number;
  locationId: number;
  externalId: string;
}
